import {
  GET_LIST_CONFIGURATION_SUCCESS,
  GET_LIST_CONFIGURATION_FAILURE,
  GET_ITEM_CONFIGURATION_SUCCESS,
  GET_ITEM_CONFIGURATION_FAILURE,
  PUT_CONFIGURATION_SUCCESS,
  CLEAN_CONFIGURATION,
} from "../../../../constants/actionTypes";
const INITIAL_STATE = {
  list: [],
  data: {},
  status: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_LIST_CONFIGURATION_SUCCESS:
      return {
        ...state,
        list: action.payload.Retorno,
      };
    case GET_LIST_CONFIGURATION_FAILURE:
      return {
        ...state,
        status: 400,
      };
    case GET_ITEM_CONFIGURATION_SUCCESS:
      return {
        ...state,
        data: action.payload.Retorno,
      };
    case GET_ITEM_CONFIGURATION_FAILURE:
      return {
        ...state,
        status: 400,
      };
    case PUT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        data: {
          message: action.payload.Mensagem,
          status: action.payload?.StatusCode,
        },
      };
    case CLEAN_CONFIGURATION:
      return {
        ...state,
        list: [],
      };
    default:
      return state;
  }
};
